import { useSelector } from 'react-redux';
import { Dropdown } from '../shared';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { selectBoats } from '../../store/users/users.selector';

interface Props {
  className?: string;
  label?: string;
  value?: number | null;
  onChange?: (value: number | null) => void;
  disabled?: boolean;
}

const SelectBoat = ({ className, label, value, onChange, disabled }: Props) => {
  const lang = useSelector(selectLang);
  const boats = useSelector(selectBoats);

  return (
    <Dropdown
      className={className}
      label={label ?? translate(lang, 'Vessel')}
      options={boats.map(x => ({
        id: x.id.toString(),
        value: x.id.toString(),
        label: `${x.name} (${x.reg_number})`,
      }))}
      value={value?.toString() ?? undefined}
      onChange={v => onChange && onChange(v ? Number(v) : null)}
      disabled={disabled}
    />
  );
};

export default SelectBoat;
